export default () => {
    const cards = document.querySelectorAll('.wlpbCard');
    cards.forEach(card => {
        card.addEventListener('click', () => {
            const radio = card.querySelector('input[type="radio"]');
            radio.click();
            document.body.dispatchEvent(new Event('wlpbCardClicked'));
        });
    });

    document.body.addEventListener('wlpbCardClicked', () => {
        cards.forEach(card => {
            const radio = card.querySelector('input[type="radio"]');

            card.classList.remove('active');
            if(radio.checked) card.classList.add('active');
        });

        updateNavigationState();
    });

    const nextButton = document.querySelector('.wlpb__navigation--next[data-requires-selection]');
    const errorMessage = document.querySelector('.wlpb__navigation--error');
    const form = nextButton ? nextButton.closest('form') : null;
    
    const hasSelection = () => !!(form && form.querySelector('input[type="radio"]:checked'));

    function updateNavigationState() {
        if(!nextButton) return;

        const selected = hasSelection();
        nextButton.classList.toggle('is-disabled', !selected);
        if(selected && errorMessage) errorMessage.hidden = true;
    }

    if(nextButton) {
        if(form) form.addEventListener('change', updateNavigationState);

        nextButton.addEventListener('click', e => {
            if(!hasSelection()) {
                e.preventDefault();
                if(errorMessage) errorMessage.hidden = false;
            }
        });

        updateNavigationState();
    }
}